// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2ZW-X","file":"styles_file__2mfpL"};